import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { State } from '@macs-frontend/reducers';
import { Store } from '@ngrx/store';
import { fromEvent, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[mdScrollToTop]',
})
export class ScrollToTopDirective extends BaseComponent implements OnDestroy {
  @Input('mdScrollToTop') event = 'blur';

  subscription: Subscription;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<State>,
  ) {
    super();
    this.subscription = fromEvent(this.elementRef.nativeElement, this.event)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.elementRef.nativeElement.scrollTop = 0;
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscription.unsubscribe();
  }
}
